$(document).ready(function(){

	var heroSlider = $(".hero-slider__inner");

	heroSlider.slick({
		slidesToShow : 1,
		slidesToScroll: 1,
		arrows : false,
		dots: false,
		fade: true,
		speed: 1000,
		autoplay : true,
		cssEase: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
		autoplaySpeed : 6000
	});


});



/*
$(document).ready(function(){


	var $stage = $('.stage__inner');
	var $stageStatus = $('.stage__status');

	var $stageSlidesToShow = 1;
	var $stageSlidesToShowTablet = 1;
	var $stageSlidesToShowMobile = 1;

	var $stageSlidesToScroll = $stageSlidesToShow;
	var $stageSlidesToScrollTablet = $stageSlidesToShowTablet;
	var $stageSlidesToScrollMobile = $stageSlidesToShowMobile;

	var $stageVariableWidth = false;
	var $stageAdaptiveHeight = false;
	var $stageCenterMode = false;

	var $stageFade = false;


	// Getting current slide and total number of slides for a compact replacement of the dot nav on mobile

	$stage.on('onLoad init reInit afterChange', function (event, slick, currentSlide, nextSlide) {

        // currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)

        var i = (currentSlide ? currentSlide : 0) + 1;

        $stageStatus.html('<span>' + i + '</span>' + '/' + '<span>' + slick.slideCount + '</span>');

    });


	// Counting all instances of inner slide elements
	// Regardless if they share an outer parent slide or not

    $stage.on('init', function(event){

		var $stageCard = $('.stage--stacked .stage__card');

    	$stageCard.each(function (i) {

		    if( !( i % 2 ) ) {
		        $(this).addClass('stage__card--pull-up');
		    }

		});

	});


	$('.stage').each(function(){

		$stage = $(this);

		// Setting the max numbers of slides shown

		if ( $(this).hasClass("stage--wide") ) {
			$stageSlidesToShow = 1;
			$stageSlidesToShowTablet = 1;
			$stageSlidesToShowMobile = 1;
			$stageSlidesToScroll = 1;
			$stageSlidesToScrollTablet = 1;
			$stageSlidesToScrollMobile = 1;
			$stageFade = true;
		}

		// Setting the handling of differently sized images

		if ( $(this).hasClass("stage--variable-width") ) {
			$stagevariableWidth = true;
		}

		if ( $(this).hasClass("stage--center-mode") ) {
			$stageCenterMode = true;
		}

		if ( $(this).hasClass("stage--adaptive-height") ) {
			$stageAdaptiveHeight = true;
			$stageSlidesToShow = 1;
			$stageSlidesToShowTablet = 1;
			$stageSlidesToShowMobile = 1;
		}


		// Init Slick Slider

		$(".stage__inner", this).slick({
		// $stage.slick({
			slidesToShow : $stageSlidesToShow,
			slidesToScroll: $stageSlidesToScroll,
			arrows : true,
			prevArrow: $stage.parent().find('.stage__arrow--prev'),
			nextArrow: $stage.parent().find('.stage__arrow--next'),
			dots: true,
			//appendDots: $stage,
			//appendDots: $stage.find(".stage__dots"),
			slide : '.stage__item',
			fade: true,
			speed: 500,
			autoplay : false,
			autoplaySpeed : 5000,
			variableWidth : $stageVariableWidth,
			centerMode: $stageCenterMode,
			adaptiveHeight: $stageAdaptiveHeight,

			responsive : [
				{
				breakpoint: 992,
					settings: {
						slidesToShow: $stageSlidesToShowTablet,
						slidesToScroll: $stageSlidesToScrollTablet
					}
				},
				{
				breakpoint: 720,
					settings: {
						slidesToShow: $stageSlidesToShowMobile,
						slidesToScroll: $stageSlidesToScrollMobile,
						dots: false,
						variableWidth : false,
						adaptiveHeight : false
					}
				},
				{
				breakpoint: 480,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						dots: false,
						variableWidth : false,
						adaptiveHeight : false
					}
				}
			]
		});

		$stageSlidesToShow = 2;
		$stageSlidesToShowTablet = 1;
		$stageSlidesToShowMobile = 1;

		$stageSlidesToScroll = 2;
		$stageSlidesToScrollTablet = 2;
		$stageSlidesToScrollMobile = 1;

		$stageVariableWidth = false;
		$stageAdaptiveHeight = false;
		$stageCenterMode = false;


	});

});
*/
